/* unplugin-vue-components disabled */import { render } from "./TopTitle.vue?vue&type=template&id=bda4fde2&scoped=true"
import script from "./TopTitle.vue?vue&type=script&lang=js"
export * from "./TopTitle.vue?vue&type=script&lang=js"

import "./TopTitle.vue?vue&type=style&index=0&id=bda4fde2&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/mianjuyry-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bda4fde2"]])

export default __exports__